import { useContext, useState } from 'react';

import { CallInfo } from '@Components/CallInfo';
import { WhatHappensNext } from '@Components/WhatHappensNext';
import { ApplicationContext } from '@src/app/contexts/Application';
import { Offer } from '@src/app/interfaces/offer';
import OfferHelp from '@src/ui/components/Help/OfferHelp';
import OfferCard from '@src/ui/components/OfferCard/OfferCard';

interface ConfirmationViewProps {
    offer?: Offer;
    callDate: string;
    callTime: string;
    navigateLink: string;
    whatHappensNextItems: string[];
    expectCall?: any;
}

const ConfirmationView = ({
    offer,
    callDate,
    callTime,
    navigateLink,
    whatHappensNextItems,
    expectCall,
}: ConfirmationViewProps) => {
    const [expanded, setExpanded] = useState(false);
    const { hasDeclinedOffer } = useContext(ApplicationContext);

    return (
        <>
            <div className='flex flex-col items-center mx-auto max-w-400 w-full lg:hidden'>
                <CallInfo
                    callDate={callDate}
                    callTime={callTime}
                    navigateLink={navigateLink}
                    expectCall={expectCall}
                />
                {offer && (
                    <>
                        <p className='text-lg font-sora-bold self-start'>
                            Your selected quote
                        </p>
                        <p className='text-sm mb-4 self-start'>
                            Subject to underwriting
                        </p>
                        <div className='w-full'>
                            <OfferCard
                                offer={offer}
                                selected={false}
                                selectable={false}
                                expanded={expanded}
                                toggle={() => setExpanded((prev) => !prev)}
                                className='pt-6'
                                hasDeclinedOffer={hasDeclinedOffer}
                            />
                        </div>
                    </>
                )}

                <p className='text-sm leading-120% mb-8 mt-4 text-center'>
                    Your home may be repossessed if you do not keep up
                    repayments on a mortgage or any other debt secured on it
                </p>
                <WhatHappensNext items={whatHappensNextItems} />
                <OfferHelp />
            </div>

            {/* Desktop */}
            <div className='hidden lg:block'>
                <div className='flex flex-col items-center'>
                    <CallInfo
                        callDate={callDate}
                        callTime={callTime}
                        navigateLink={navigateLink}
                        expectCall={expectCall}
                    />
                    <p className='text-sm leading-120% mb-4 text-center max-w-400'>
                        Your home may be repossessed if you do not keep up
                        repayments on a mortgage or any other debt secured on it
                    </p>
                </div>
                <div className='flex justify-center items-start bg-monochrome-100 space-x-8 pt-13 min-h-screen'>
                    {offer && (
                        <div className='w-full max-w-400'>
                            <p className='text-xl font-sora-bold'>
                                Your selected quote
                            </p>
                            <p className='text-sm mb-4'>
                                Subject to underwriting
                            </p>
                            <div className='w-full max-w-400'>
                                <OfferCard
                                    offer={offer}
                                    selected={false}
                                    selectable={false}
                                    expanded={expanded}
                                    toggle={() => setExpanded((prev) => !prev)}
                                    hasDeclinedOffer={hasDeclinedOffer}
                                />
                            </div>
                        </div>
                    )}

                    <WhatHappensNext items={whatHappensNextItems} />
                </div>
            </div>
        </>
    );
};

export default ConfirmationView;
